export const ADMIN_PATH = {
  ROOT_PATH: '/',
  HUB_PATH: '/admin',
  SIGNIN_PATH: '/admin/signin',
  STUDENT_LIST_PATH: '/admin/student',
  EXPRESSION_LIST_PATH: '/admin/expression',
  EXPRESSION_DETAIL_PATH: '/admin/expression/:expressionKey',
  CLOZE_LIST_PATH: '/admin/cloze',
  VOCABULARY_BOOK_LIST_PATH: '/admin/vocabulary-book',
};

export const createExpressionDetailPath = (expressionKey: string) => `/admin/expression/${expressionKey}`;
